export const getGraphLayoutPosition = (
  i: string,
  idx: number
): {
  h: number
  i: string
  minH: number
  minW: number
  w: number
  x: number
  y: number
} => ({
  h: 4,
  i,
  minH: 3,
  minW: 4,
  w: 12,
  x: 0,
  y: idx * 4,
})

export const getDataLayoutPosition = (
  i: string,
  { x, y }: { x?: number; y?: number }
): {
  h: number
  i: string
  minH: number
  minW: number
  w: number
  x: number
  y: number
} => ({
  h: 1.7,
  i,
  minH: 1.7,
  minW: 3,
  w: 3,
  x: x ? x * 3 : 0,
  y: y ? y * 1.7 : 0,
})
